import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PackagesData from '../data/Packages/packages.json';
import '../styles/Pages/PackageDetailPage.css';
import { Spinner, SpinnerContainer } from '../styles/Spinner';
import Navigation from '../components/Navigation/Navigation';
import PhoneButton from '../components/PhoneButton';
import Footer from '../components/Footer';

const PackageDetailPage = () => {
  const { id } = useParams();
  const [packageData, setPackageData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const selectedPackage = PackagesData.find(pkg => pkg.packageId.toString() === id);
    setPackageData(selectedPackage);
  }, [id]);

  if (!packageData) return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  );

  const imagePath = require(`../data/Images/${packageData.image}`);

  return (
    <div>
      <Navigation />
      <PhoneButton />
      <div className="package-detail-page">
        <div className="package-content-wrapper">
          <h1>{packageData.packageName}</h1>
          <p className="package-description">{packageData.description}</p>

          <div className="package-image-container">
            <img src={imagePath} alt={packageData.packageName} className="package-image" />
          </div>

          <div className="package-grid">
            <div className="package-section package-duration">
              <h3>Package Duration:</h3>
              <ul>
                <li><strong>Short Trip</strong>: {packageData.duration.short}</li>
                <li><strong>Standard Package</strong>: {packageData.duration.standard}</li>
                <li><strong>Extended Journey</strong>: {packageData.duration.extended}</li>
              </ul>
            </div>

            <div className="package-section package-pricing">
              <h3>Pricing Options:</h3>
              <ul>
                {packageData.pricing.economy && <li><strong>Economy</strong>: {packageData.pricing.economy}</li>}
                {packageData.pricing.premium && <li><strong>Premium</strong>: {packageData.pricing.premium}</li>}
                {packageData.pricing.luxury && <li><strong>Luxury</strong>: {packageData.pricing.luxury}</li>}
                {packageData.pricing.ultraLuxury && <li><strong>Ultra Luxury</strong>: {packageData.pricing.ultraLuxury}</li>}
              </ul>
            </div>
          </div>

          <div className="package-section package-destinations">
            <h3>Featured Destinations:</h3>
            <div className="destinations-grid">
              {packageData.destinations.map((destination, index) => (
                <div key={index} className="destination-card">
                  <h4>{destination.location}</h4>
                  <p>{destination.highlights}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="package-section package-inclusions">
            <h3>Package Inclusions:</h3>
            <ul>
              {packageData.inclusions.map((inclusion, index) => (
                <li key={index}>{inclusion}</li>
              ))}
            </ul>
          </div>

          <div className="package-grid">
            <div className="package-section package-booking-options">
              <h3>Booking Options:</h3>
              <ul>
                {packageData.bookingOptions.map((option, index) => (
                  <li key={index}>{option}</li>
                ))}
              </ul>
            </div>

            <div className="package-section package-offers">
              <h3>Seasonal Offers:</h3>
              <ul>
                {packageData.seasonalOffers.map((offer, index) => (
                  <li key={index}>{offer}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="package-section package-why-choose">
            <h3>Why Choose This Package:</h3>
            <div className="why-choose-grid">
              {packageData.whyChoose.map((reason, index) => (
                <div key={index} className="why-choose-item">
                  <span className="check-mark">✓</span>
                  <span>{reason}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="package-grid">
            <div className="package-section package-support">
              <h3>Customer Support:</h3>
              <ul>
                {packageData.support.map((supportItem, index) => (
                  <li key={index}>{supportItem}</li>
                ))}
              </ul>
            </div>

            <div className="package-section package-addons">
              <h3>Available Add-ons:</h3>
              <ul>
                {packageData.addOns.map((addon, index) => (
                  <li key={index}>{addon}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="package-section package-airlines">
            <h3>Partner Airlines:</h3>
            <div className="airlines-list">
              {packageData.airlines.map((airline, index) => (
                <span key={index} className="airline-tag">{airline}</span>
              ))}
            </div>
          </div>

          <div className="package-actions">
            <button onClick={() => navigate(-1)} className="back-button">Go Back</button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PackageDetailPage;
